import { PixelAlert, colors } from 'pixel-base'
import styled, { css } from 'styled-components'
const Section = styled.div<{ isMobile?: boolean }>`
  width: 100%;
  height: auto;
  padding: 10px 20px;
  ${({ isMobile }) =>
    isMobile &&
    css`
      padding: 5px;
    `}
  &.fullheight {
    height: 100%;
  }
`
const SectionTitle = styled.div<{ color?: string; size?: string }>`
  font-size: ${(props) => props.size || '20px'};
  font-weight: bold;
  color: ${(props) => props.color || colors.grayTextDark};
  margin-bottom: 15px;
`
const SectionContent = styled.div<{ isMobile?: boolean }>`
  width: 100%;
  height: auto;
  padding: 10px 20px;
  background: ${colors.white};
  border-radius: 5px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  min-height: 100px;
  ${({ isMobile }) =>
    isMobile &&
    css`
      padding: 5px;
    `}
  &.fullheight {
    min-height: 100%;
    height: 100%;
  }
`
const SectionForm = styled.form<{ columnItems: string; isMobile: boolean }>`
  display: grid;
  grid-template-columns: ${(props) => '1fr '.repeat(Number(props.columnItems))};
  grid-auto-columns: auto;
  grid-auto-rows: auto;
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  ${({ isMobile }) =>
    isMobile &&
    css`
      grid-template-columns: 1fr;
    `}
`
const SectionHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  margin-bottom: 15px;
`
const SectionActions = styled.div`
  // right align items
  display: inline-flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  align-content: center;
`

const FilterInput = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  width: 250px;
  gap: 10px;
`
const InputLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: ${colors.grayTextMedium};
  margin-left: 10px;
`
const StartDate = styled.p`
  color: ${colors.grayTextLight};
  font-weight: 400;
  font-size: 20px;
  line-height: 100%;
  text-align: right;
`
const DataSections = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`

const ContentBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  padding: 0 15px;
  background-color: ${colors.white};
  box-shadow: rgb(0 0 0 / 50%) 0px 0px 1px inset;
`
const HeaderBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background-color: ${colors.grayLightBg};
  box-shadow: rgb(0 0 0 / 50%) 0px 0px 1px inset;
  padding: 0 15px;
`
const Header = styled.span<{ justify?: string }>`
  text-transform: capitalize;
  line-height: 43px;
  margin-left: 15px;
  font-size: 14px;
  color: ${colors.text};
  font-weight: 600;
  justify-self: ${(props) => props.justify || 'flex-end'};
`
const Content = styled.div`
  width: calc(100% - 300px);
  height: 100%;
  &.collapsed {
    width: calc(100% - 100px);
  }
  transition: 0.5s all;
`
const ContainerForPopup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  align-content: stretch;
  border: 1px solid ${colors.grayBorderLight};
  max-height: calc(100vh - 350px);
  overflow: auto;
`
const ContentSection = styled.span<{ weight: string; justify: string }>`
  font-size: 12px;
  text-transform: capitalize;
  color: ${colors.text};
  font-weight: ${(props) => props.weight || '400'};
  margin-left: 20px;
  line-height: 40px;
  justify-self: ${(props) => props.justify || 'flex-end'};
`
const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  align-content: stretch;
  margin-top: 10px;
`
const Image = styled.img`
  width: 32px;
  margin-right: 5px;
`

const PlatformChoice = styled.div<{ padding?: string }>`
  color: rgba(104, 118, 140, 0.8);
  font-size: 15px;
  line-height: 1.5;
  margin: 15px auto;
  max-width: 450px;
  font-weight: 600;
  align-self: center;
  padding: ${(props) => props.padding || '0px'};
`

const WebsiteDataContainer = styled.div`
  border-top: 1px solid ${colors.grayBorderLight};
  padding: 0px;
  ${PlatformChoice} {
    text-align: center;
  }
`
const WebsiteDataTitle = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: ${colors.primary};
`
const WebsiteDataURL = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: darkgrey;
`
const ManualFormHelp = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 1);
  padding: 10px;
  transition: 0.4s all;
  height: 0;
  opacity: 0;
  visibility: hidden;
  overflow: hidden;
  &.show {
    height: 100%;
    opacity: 1;
    visibility: visible;
    overflow: auto;
  }
`

const ManualFormHelpCloseButton = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 99999;
  cursor: pointer;
  font-size: 25px;

  border-radius: 15px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  align-content: center;
`
const FormError = styled(PixelAlert)``

export {
  Section,
  SectionTitle,
  SectionContent,
  SectionForm,
  SectionHeader,
  SectionActions,
  FilterInput,
  InputLabel,
  StartDate,
  DataSections,
  ContentBar,
  HeaderBar,
  Header,
  Content,
  ContainerForPopup,
  ContentSection,
  ButtonContainer,
  Image,
  PlatformChoice,
  WebsiteDataContainer,
  WebsiteDataTitle,
  WebsiteDataURL,
  ManualFormHelp,
  FormError,
  ManualFormHelpCloseButton,
}
